import { BaseSurvey } from '../base-survey';
import { validateESCSignupTriggerCondition } from '../utils';
import { ESCWebUIUserCancelSignupSurveyView } from './view';

export class EscWebuiUserCancelSignupSurvey extends BaseSurvey {
  getSurveyName = () => 'EscWebuiUserCancelSignupSurvey';

  getSurveyId = () => 'ec6cdc61-9e98-4e85-a5f0-065cce464ce2';

  validateTriggerCondition = () => validateESCSignupTriggerCondition(this, 'EscUserCancelSignup');

  getSurveyComponent = () => ESCWebUIUserCancelSignupSurveyView;

  onSurveySubmit = () => {
    window.survey.EscUserCancelSignup = false;
    delete window.survey.EscUserCancelSignupCustomParams;
  };

  onSurveyDismiss = () => {
    window.survey.EscUserCancelSignup = false;
    delete window.survey.EscUserCancelSignupCustomParams;
  };

  getSurveyCustomParams = () => window.survey.EscUserCancelSignupCustomParams;
}
